<template>
  <div>
    <el-drawer
        :modal="true"
        :show-close="false"
        :visible="visible"
        :with-header="false"
        class="mobile-drawer"
        direction="ltr"
        size="280px"
        @close="handleDrawerClose"
    >
      <div class="drawer-content">
        <div class="drawer-header" @click="$emit('agentOpen')">
          <div class="action-logo"><img src="@/assets/images/logo.png"/>
            <span>数字枢纽</span></div>
          <div
              class="drawer-close-btn"
              role="button"
              tabindex="0"
              @click="handleClose"
          >
            <SvgIcon
                color="rgb(139, 139, 139)"
                name="menu-left"
                size="28"
                style="flex-shrink: 0"
            />
          </div>
        </div>
        <div
            class="drawer-new-chat"
            @click="handleNewChat"
        >
          <div>
            <SvgIcon
                color="#ffffff"
                name="plus"
                size="28"
            />
          </div>
          新对话
          <!--        <span class="keyboard-shortcut">Ctrl+K</span>-->
        </div>
        <div class="history-box">
          <img src="@/assets/images/home1.png"/>
          <span>历史会话</span>
        </div>
        <el-x-conversations
            v-if="conversationList.length"
            v-loading="isLoadingConversations"
            :active="activeConversation"
            :groupable="true"
            :items="conversationList"
            :label-max-width="190"
            :menu="customMenu"
            :show-built-in-menu="true"
            :styleConfig="{ width: '100%', backgroundColor: '#ECF5FF', padding: 0 }"
            class="drawer-conversation-list"
            @change="handleConversationChange"
            @menu-command="$emit('menu-command', $event, arguments[1])"
        >
          <!-- 分组标题：左侧标题 + 数量，右侧展开/收起箭头 -->
          <template #group-title="{ group }">
            <div
                :class="{ 'is-collapsed': isGroupCollapsed(group) }"
                class="group-title-row"
                @click="toggleGroup(group, $event)"
            >
              <span class="group-title-text">{{ group.title }}</span>
              <i
                  :class="{ 'is-collapsed': isGroupCollapsed(group) }"
                  class="el-icon-arrow-down group-title-arrow"
              ></i>
            </div>
          </template>
          <!-- 会话项：标题 + 右侧删除按钮 -->
          <template #label="{ item }">
            <div class="conversation-item-row">
              <span class="item-label">{{ item.label }}</span>
              <i
                  class="el-icon-delete item-delete-btn"
                  title="删除该对话"
                  @click.stop="handleItemDelete(item)"
              ></i>
            </div>
          </template>
        </el-x-conversations>
        <el-empty
            v-else
            description="请开始今天的聊天吧"
        ></el-empty>
        <div class="logout-box">
          <el-popover
              v-model="userMenuVisible"
              placement="top-end"
              popper-class="popper-logout"
          >
            <div class="user-flex" @click="userClick('set')">
              <img class="el-setting" src="@/assets/images/home4.png"></img>
              <span>个人设置</span>
            </div>
            <div class="user-flex" @click="userClick('logout')">
              <img class="el-setting" src="@/assets/images/home3.png"></img>
              <span>退出登录</span>
            </div>
            <div slot="reference" class="user-info">
              <div class="logout-img">
                <img v-if="profile_info.avatar_url" :src="profile_info.avatar_url" class="img-class"/>
                <img v-else class="img-class" src="@/assets/images/avatar.png"/>
                <div class="ellipsis">{{ profile_info.nickname }}</div>
              </div>
              <img src="@/assets/images/home5.png"
                   style="width: 24px;height: 24px;display: flex;flex-shrink: 0"/>
            </div>
          </el-popover>
        </div>
      </div>
    </el-drawer>
    <Settings
        v-if="settingsVisible"
        :settingsVisible.sync="settingsVisible"
        @settingsSave="settingsSave"
    />
  </div>
</template>

<script>
import Settings from "@/components/Settings.vue";
import {logout} from "@/api/login";
import {removeToken} from "@/utils/auth";
import {toggle_collapse} from "@/api/chat";

export default {
  name: 'MobileDrawer',
  components: {Settings},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    conversationList: {
      type: Array,
      default: () => [],
    },
    activeConversation: {
      type: String,
      default: null,
    },
    collapsed_ids: {
      type: Array,
      default: () => [],
    },
    customMenu: {
      type: Array,
      default: () => [],
    },
    isLoadingConversations: {
      type: Boolean,
      default: false,
    },
    profile_info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      settingsVisible: false,
      isClosing: false,
      userMenuVisible: false,
      // 本次点击切换过的 robot_id -> 是否收起（默认收起状态以父级传入的 collapsed_ids 为准）
      localToggle: {}
    }
  },
  mounted() {
  },
  methods: {
    userClick(type) {
      if (type === 'logout') {
        logout().then(() => {
          removeToken()
          this.$router.replace('/')
        }).catch(() => {
        })
      } else {
        this.settingsVisible = true
        this.userMenuVisible = false
      }
    },
    settingsSave() {
      this.$emit("settingsSaveClick");
    },
    debouncedClose() {
      if (this.isClosing) return;
      this.isClosing = true;
      this.$emit('close');
      setTimeout(() => {
        this.isClosing = false;
      }, 100);
    },
    handleClose() {
      this.debouncedClose();
    },
    handleDrawerClose() {
      this.debouncedClose();
    },
    handleNewChat() {
      this.$emit('new-chat');
      this.$emit('close');
    },
    handleConversationChange(conversation) {
      this.$emit('conversation-change', conversation);
      this.$emit('close');
    },
    // 判断分组是否收起：默认按父级传入的 collapsed_ids 判断，本次点击切换过的以本地记录为准
    isGroupCollapsed(group) {
      const info = this.getGroupRobotId(group);
      if (!info || info.robot_id == null) return false;
      const rid = String(info.robot_id);
      const base = (this.collapsed_ids || []).some(id => String(id) === rid);
      return this.localToggle[rid] !== undefined ? this.localToggle[rid] : base;
    },
    // 解析分组对应的机器人信息：优先取会话自带的字段
    getGroupRobotId(group) {
      if (!group) return null;
      const item = group.children && group.children[0];
      if (item && item.robot_id != null) return {
        robot_id: item.robot_id,
        name: group.key || group.title,
        is_collapsed: item.is_collapsed,
      }
    },
    // 切换分组的展开/收起：本地状态即时生效 + 调接口保存
    // 同时用 max-height 过渡做平滑折叠动画（display:none / grid 轨道动画均有闪烁问题）
    toggleGroup(group, event) {
      const info = this.getGroupRobotId(group);
      if (!info || info.robot_id == null) return; // 拿不到 robot_id（如临时会话），忽略
      const collapsed = !this.isGroupCollapsed(group);
      // 提前取出 DOM，避免异步回调中 currentTarget 已失效
      const titleRow = event && event.currentTarget;
      this.$set(this.localToggle, String(info.robot_id), collapsed);
      this.animateGroupCollapse(titleRow, collapsed);
      toggle_collapse({
        robot_id: info.robot_id,
        is_collapsed: collapsed,
      }).catch(() => {
        // 接口失败时回滚本地状态
        this.$set(this.localToggle, String(info.robot_id), !collapsed);
        this.animateGroupCollapse(titleRow, !collapsed);
        this.$message.error('保存分组状态失败');
      });
    },
    // 根据分组标题行定位会话列表 DOM，用 max-height 精确高度做折叠/展开动画
    // 先锁定当前真实高度再过渡到目标高度，保证动画节奏与内容高度一致、不瞬跳
    animateGroupCollapse(titleRow, collapsed) {
      const itemsEl = titleRow && titleRow.parentElement && titleRow.parentElement.parentElement
          && titleRow.parentElement.parentElement.querySelector('.el-x-conversation-group-items');
      if (!itemsEl) return;
      if (itemsEl._collapseTimer) clearTimeout(itemsEl._collapseTimer);
      const clearMaxHeight = () => {
        itemsEl.style.maxHeight = '';
        itemsEl.removeEventListener('transitionend', clearMaxHeight);
        itemsEl._collapseTimer = null;
      };
      // 锁定额外高度 → 强制回流 → 过渡到目标高度
      itemsEl.style.maxHeight = collapsed ? itemsEl.scrollHeight + 'px' : '0px';
      itemsEl.getBoundingClientRect();
      itemsEl.style.maxHeight = collapsed ? '0px' : itemsEl.scrollHeight + 'px';
      // 动画结束后清除内联高度恢复自适应；transitionend 未触发时定时兜底
      itemsEl.addEventListener('transitionend', clearMaxHeight);
      itemsEl._collapseTimer = setTimeout(clearMaxHeight, 400);
    },
    // 点击会话项右侧删除按钮
    handleItemDelete(item) {
      this.$emit('delete-conversation', item);
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #F7F7F7;
$--color-text-primary: #303133;
$--color-text-regular: #606266;
$--border-color-lighter: #eeeeee;
::v-deep .el-x-conversations-list {
  background: #ECF5FF !important;
  border: 0 !important;
}

::v-deep .el-x-conversations-container {
  box-shadow: none !important;
}

::v-deep .el-x-conversation-group .sticky-title {
  background: #ECF5FF !important;
}

// --- 会话列表 hover/active 配色（Element UI light 色阶） ---
::v-deep .el-x-conversation-item.active {
  background-color: #c6e2ff !important;
}

::v-deep .el-x-conversation-item.hovered,
::v-deep .el-x-conversation-item:hover {
  background-color: #d9ecff !important;
}

::v-deep .el-x-conversation-item.menu-opened {
  background-color: #c6e2ff !important;
}

.mobile-drawer {
  .drawer-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #ECF5FF;
    position: relative;

    .drawer-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px;
      border-bottom: 1px solid $--border-color-lighter;

      .action-logo {
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
          width: 32px;
          height: 32px;
          display: flex;
        }

        span {
          font-weight: 500;
          font-size: 20px;
          color: #333333;
          line-height: 28px;
          margin-left: 12px;
          display: inline-block;
          min-width: 100px;
        }
      }

      .drawer-close-btn {
        width: 28px;
        height: 28px;
        padding: 8px;
        font-size: 16px;
        color: $--color-text-regular;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        transition: background-color 0.2s ease;

        // 移动端触摸优化
        touch-action: manipulation;
        user-select: none;
        -webkit-tap-highlight-color: transparent;

        // 悬停效果
        &:hover {
          background-color: rgba(0, 0, 0, 0.05);
        }

        // 激活效果
        &:active {
          background-color: rgba(0, 0, 0, 0.1);
        }

        // 焦点样式（键盘导航）
        &:focus {
          outline: 2px solid $--color-primary;
          outline-offset: 2px;
        }
      }
    }

    .drawer-new-chat {
      width: 28px;
      height: 28px;
      margin: 16px;
      color: #FFFFFF;
      background-color: #4D79FF;
      cursor: pointer;
      height: 44px;
      border-radius: 14px;
      align-items: center;
      width: calc(100% - 32px);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      display: flex;
      padding: 0 16px;
      transition: background-color 0.2s ease;

      &:hover {
        //background-color: #c6dcf8;
      }

      .keyboard-shortcut {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-left: auto;
        padding: 0 6px;
        height: 20px;
        font-size: 12px;
        color: #909399;
        background-color: #F7F7F7;
        border-radius: 4px;
        border: 1px solid #e4e7ed;
      }
    }

    .drawer-conversation-list {
      flex: 1;
      overflow-y: auto;
      padding: 0 0 68px 16px;
      width: 100%;
    }
  }
}

// 分组标题行（图标由 #group-title 插槽渲染）
.group-title-row {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding: 8px;

  .group-title-text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  // 箭头固定在最右侧，展开/收起状态位置一致；旋转代替图标硬切换
  .group-title-arrow {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    transition: transform 0.3s ease;
    font-size: 12px;
    line-height: 1;
    color: #909399;

    &.is-collapsed {
      transform: translateY(-50%) rotate(-90deg);
    }
  }
}

// 会话项行（#label 插槽）：标题 + 右侧删除按钮
.conversation-item-row {
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;

  .item-label {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .item-delete-btn {
    margin-left: 8px;
    font-size: 14px;
    color: #909399;
    cursor: pointer;
    // 移动端无 hover，删除按钮常显
    transition: color 0.2s ease;

    &:active {
      color: #F56C6C;
    }
  }
}

// 分组间距与桌面端保持一致
::v-deep .el-x-conversation-group {
  margin-bottom: 16px;

  .el-x-conversation-item + .el-x-conversation-item {
    margin-top: 0 !important;
  }
}

::v-deep .el-x-conversation-group .el-x-conversation-group-title {
  position: relative;
}

.history-box {
  display: flex;
  align-items: center;
  color: #333333;
  line-height: 48px;

  img {
    margin-left: 6px;
    width: 24px;
    height: 24px;
    display: flex;
  }

  span {
    margin-left: 8px;
  }

}

::v-deep .el-icon-chat-dot-round {
  display: none !important;
}

.logout-box {
  overflow: hidden;
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  font-weight: 500;
  color: #0B132B;
  height: 60px;
  line-height: 40px;
  background: #ECF5FF !important;
  z-index: 99;

  .user-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px 0 20px;
    height: 40px;

    .logout-img {
      display: flex;
      align-items: center;
      overflow: hidden;
      width: 100%;

      .img-class {
        width: 24px;
        height: 24px;
        border-radius: 12px;
        display: flex;
        flex-shrink: 0;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.1);
        margin-right: 8px;
      }

      span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-left: 8px;
      }
    }
  }

}

.user-flex {
  display: flex;
  align-items: center;
  height: 36px;
  line-height: 36px;
  color: #0B132B;
  cursor: pointer;

  .el-setting {
    width: 16px;
    height: 16px;
    display: flex;
    margin-right: 12px;
  }
}
</style>
<style lang="scss">
// 分组折叠动画：JS 精确测量内容高度 + max-height 过渡实现平滑收起/展开（display:none 不可动画）
// 收起状态由 :has() 保证初次渲染即生效；切换动画由 toggleGroup 用内联 max-height 驱动
.el-x-conversation-group .el-x-conversation-group-items {
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.el-x-conversation-group:has(.group-title-row.is-collapsed) .el-x-conversation-group-items {
  max-height: 0;
}

.popper-logout.el-popover {
  min-width: 122px !important;
  border-radius: 12px;
  padding: 8px 0;

  .user-flex {
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: #f5f5f5;
    }
  }
}
</style>
